import Vue from 'vue'
import App from './App.vue'
import router from './utils/Router'
import store from './utils/Store'
import i18n from './utils/I18n'
import './utils/EventBus'

Vue.config.productionTip = false

require('@/assets/css/w3.css')
require('@/assets/css/w3-theme.css')

// Load the API base URL from runtime config.
let apiBaseUrl = 'http://localhost/'
if (typeof _API_BASE_URL === 'string' && _API_BASE_URL !== '') {
    apiBaseUrl = _API_BASE_URL.endsWith('/') ? _API_BASE_URL : `${_API_BASE_URL}/`
}
Vue.prototype.$apiBaseUrl = apiBaseUrl

window.i18n = i18n
new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')
